// Shared status colors that match the on-map markers and KPI tiles.
// Color legend (per product spec, updated 2026-08-29):
//   Accepted (received from pharmacy, no route yet) → Light blue
//   On Route / In Transit                            → Medium blue
//   Delivered                                        → Green
//   Failed                                           → Red
//   Returned                                         → Orange
//   Unassigned SAME DAY  (not yet accepted, no route) → Yellow
//   Unassigned NEXT DAY  (not yet accepted, no route) → Amber
//   Pick Up (deliver_type)                           → Purple (see PICKUP_COLOR in map components)
export const STATUS_HEX = {
  pending:    "#EAB308", // Unassigned Same-Day → yellow
  accepted:   "#7DBEFF", // Accepted           → light blue (received from pharmacy)
  assigned:   "#1E6FE0", // On Route           → medium blue
  in_transit: "#1E6FE0", // In Transit         → medium blue
  delivered:  "#16A34A", // Delivered          → green
  failed:     "#DC2626", // Failed             → red
  returned:   "#F97316", // Returned           → orange
};

// Distinct light amber for Unassigned + Next-Day so dispatch can visually split
// tomorrow's queue from today's on the map at a glance. Chosen to stay clearly
// lighter than orange-500 (Returned status) while still contrasting yellow.
export const UNASSIGNED_NEXT_DAY_HEX = "#F59E0B"; // Tailwind amber-500

export const STATUS_LABEL = {
  pending:    "UNASSIGNED",
  accepted:   "ACCEPTED",
  assigned:   "ON ROUTE",
  in_transit: "ON ROUTE",
  delivered:  "DELIVERED",
  failed:     "FAILED",
  returned:   "RETURNED",
};

// Marker color that also considers deliver_type: Unassigned + Next-Day gets
// the darker amber shade, everything else falls back to STATUS_HEX. Callers
// pass the already-resolved effective status so we don't recompute it here.
export function markerColor(order, effectiveStatusStr) {
  if (effectiveStatusStr === "pending" && (order?.deliver_type || "").toLowerCase() === "next_day") {
    return UNASSIGNED_NEXT_DAY_HEX;
  }
  return STATUS_HEX[effectiveStatusStr] || STATUS_HEX.assigned;
}

// Map pin initials: 1st word + 2nd word initial. "John Michael Doe" -> "JM", "Amali" -> "AM".
// Pickup stop names ("Pickup · Marquez Pharmacy") use the pharmacy name.
export function personInitials(name, fallback = "?") {
  const cleaned = String(name || "").replace(/^\s*pickup\s*·\s*/i, "").replace(/[^A-Za-z0-9\s]/g, " ").trim();
  if (!cleaned) return fallback;
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

// Effective marker status for a stop/order considering route assignment + intake.
// Precedence: returned → delivered → failed → in_transit → assigned/route →
// accepted (received from pharmacy, awaiting route) → pending (default).
export function effectiveStatus(o) {
  if (!o) return "pending";
  if (o.status === "returned") return "returned";
  if (o.status === "delivered") return "delivered";
  if (o.status === "failed") return "failed";
  if (o.status === "in_transit") return "in_transit";
  if (o.status === "assigned" || o.route_id) return "assigned";
  if (o.received_from_pharmacy_at) return "accepted";
  return "pending";
}
